import * as React from 'react';
import { cn } from '../lib/cn';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, rows = 4, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={error || undefined}
      className={cn(
        'flex w-full rounded-md border bg-surface-elevated px-3 py-2',
        // 16px on mobile (iOS zoom-on-focus guard) via max-sm so consumer
        // overrides like `font-mono text-xs` keep winning at desktop.
        'text-sm max-sm:text-base text-text-primary placeholder:text-text-muted',
        'transition-colors duration-fast ease-out',
        'focus-visible:outline-none focus-visible:border-border-focus',
        'disabled:cursor-not-allowed disabled:opacity-60 disabled:bg-sand-50',
        'resize-y min-h-[80px]',
        error ? 'border-error-500 focus-visible:border-error-500' : 'border-border-default',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
